import { render, staticRenderFns } from "./OtherServiceAccount.vue?vue&type=template&id=d97ba868"
import script from "./OtherServiceAccount.vue?vue&type=script&lang=js"
export * from "./OtherServiceAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports